import * as Yup from 'yup'
import { NAME_FORMAT_REGEX, NAME_FORMAT_MESSAGE } from '../../../ts-utils'

// All fields optional — the BE accepts a partial body ("send only what changed").
// We only enforce *format* when a value is present.
const optionalEmail = Yup.string()
  .trim()
  .email('Enter a valid email address')
  .optional()

const numericString = (label: string) =>
  Yup.string()
    .trim()
    .matches(/^\d*\.?\d*$/, `${label} must be a number`)
    .optional()

export const editPlayerSchema = Yup.object({
  // Personal
  firstName: Yup.string()
    .trim()
    .matches(NAME_FORMAT_REGEX, {
      message: NAME_FORMAT_MESSAGE,
      excludeEmptyString: true,
    })
    .optional(),
  lastName: Yup.string()
    .trim()
    .matches(NAME_FORMAT_REGEX, {
      message: NAME_FORMAT_MESSAGE,
      excludeEmptyString: true,
    })
    .optional(),
  birthDate: Yup.string()
    .trim()
    .optional()
    .test('not-future', 'Birth date cannot be in the future', (value) => {
      if (!value) {
        return true
      }
      const d = new Date(value)
      if (Number.isNaN(d.getTime())) {
        return false
      }
      return d.getTime() <= Date.now()
    }),
  heightFt: numericString('Height (feet)'),
  heightIn: numericString('Height (inches)'),
  weight: numericString('Weight'),
  // Contact
  email: optionalEmail,
  phoneNumber: Yup.string().trim().optional(),
  alternatePhoneNumber: Yup.string().trim().optional(),
  preferredContactMethod: Yup.string().oneOf(['', 'phone', 'email']).optional(),
  // Emergency
  emergencyContactName: Yup.string().trim().optional(),
  emergencyContactRelationship: Yup.string().trim().optional(),
  emergencyContactPhone: Yup.string().trim().optional(),
  // Address (all optional; country/province are select-driven ids)
  addressStreet1: Yup.string().trim().optional(),
  addressStreet2: Yup.string().trim().optional(),
  addressCity: Yup.string().trim().optional(),
  addressPostalCode: Yup.string().trim().optional(),
  addressCountryId: Yup.string().trim().optional(),
  addressProvinceId: Yup.string().trim().optional(),
  // Membership
  leagueRegistrationNumber: Yup.string().trim().optional(),
  hockeyUsaNumber: Yup.string().trim().optional(),
  hockeyCanadaNumber: Yup.string().trim().optional(),
  customMembershipNumber: Yup.string().trim().optional(),
  loyaltyNumber: Yup.string().trim().optional(),
  // Image staging — not validated here
  imageUrl: Yup.string().optional(),
  imageData: Yup.string().optional(),
  imageDeleted: Yup.boolean().optional(),
})
